(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-kachel-hover"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.psCardGalleryHover) return;
  window.psCardGalleryHover = true;
  const cache = new Map();
  const pending = new WeakMap();
  const ready = new WeakMap();
  const mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '[data-ps-gallery-hover]';
  async function gallery(url) {
    const key = url.href;
    if (cache.has(key)) return cache.get(key);
    const promise = (async () => {
      const response = await fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Gallery unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const img = page.querySelector('.ps-map-gallery__track [data-ps-slide] img')
        || page.querySelector('media-gallery .product__media-list .product__media-item img');
      if (!img) return null;
      const source = img.getAttribute('src') || img.getAttribute('data-src');
      if (!source) return null;
      const image = new URL(source, url);
      if (!['https:', 'http:'].includes(image.protocol)) return null;
      if (image.pathname.includes('/cdn/shop/') || image.hostname === 'cdn.shopify.com') image.searchParams.set('width', '800');
      return image.href;
    })();
    cache.set(key, promise);
    try { return await promise; } catch { cache.delete(key); return null; }
  }
  async function load(media) {
    if (ready.has(media)) return;
    const link = media.closest('a');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    ready.set(media, true);
    const source = await gallery(url);
    if (!source || !media.isConnected) { ready.delete(media); return; }
    const image = new Image();
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.width = 800;
    image.height = 800;
    image.className = media.classList.contains('ps-card__media') ? 'ps-card__bild ps-card__bild--zwei' : 'motion-reduce';
    image.style.objectFit = 'contain';
    image.style.backgroundColor = '#fff';
    image.src = source;
    try { await image.decode(); } catch { ready.delete(media); return; }
    if (!media.isConnected) return;
    media.classList.add('ps-card__media--zwei');
    media.append(image);
  }
  document.addEventListener('pointerover', event => {
    if (!mouse.matches || event.pointerType === 'touch') return;
    const card = event.target.closest('.ps-card, .card-wrapper');
    const media = card?.querySelector(selector);
    if (!media || card.contains(event.relatedTarget) || ready.has(media)) return;
    clearTimeout(pending.get(media));
    pending.set(media, setTimeout(() => load(media), 80));
  });
  document.addEventListener('pointerout', event => {
    const card = event.target.closest('.ps-card, .card-wrapper');
    const media = card?.querySelector(selector);
    if (media && !card.contains(event.relatedTarget)) clearTimeout(pending.get(media));
  });
  document.addEventListener('focusin', event => {
    const card = event.target.closest('.ps-card, .card-wrapper');
    const media = card?.querySelector(selector);
    if (media) load(media);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
